import { render } from "./_ChatVideo.vue?vue&type=template&id=cd28658e"
import script from "./_ChatVideo.vue?vue&type=script&lang=js"
export * from "./_ChatVideo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__